/**
 * Whether a patient chart is currently on screen.
 *
 * Read from `window.location` at call time rather than through `usePathname`
 * on purpose. Callers are leaf components rendered in a lot of places, and a
 * hook would make every one of their contexts — and every one of their tests —
 * responsible for providing a router. Checking at click time is also more
 * accurate than a value captured at render.
 */
export function isOnPatientChart(): boolean {
  return currentChartPatientId() !== null;
}

/** The patient whose chart is on screen, or null when none is. */
export function currentChartPatientId(): string | null {
  if (typeof window === "undefined") return null;
  // Requires the `usr_` id prefix on purpose. `/patient/` also fronts merge,
  // cohorts, upload-history and the upload page, and a bare segment match
  // would treat all of those as a chart.
  return (
    window.location.pathname.match(/\/patient\/(usr_[^/?#]+)/)?.[1] ?? null
  );
}
